import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TabMenu = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px 12px 0px 0px;
  background: ${({ theme }) => theme.colors.default[100]};
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  align-self: stretch;
`;

export const TabMenuItem = styled.div<{ $active: boolean }>`
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  height: 45px;
  cursor: pointer;
  border-radius: 12px 12px 0px 0px;
  background: ${({ theme, $active }) =>
    $active ? theme.colors.base : theme.colors.default[100]};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary[600] : theme.colors.default[400]};
  text-overflow: ellipsis;
  text-wrap: nowrap;
  font-size: 14px;
  font-style: normal;
  font-weight: 550;
  line-height: 150%; /* 21px */
  flex: 1;
`;

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 48px;
  align-items: center;
  gap: 94px;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.base};
  border-radius: 0px 0px 24px 24px;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    gap: 24px;
    padding: 48px 24px;
  }
`;

export const TabContent = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  height: 380px;
  width: 50%;
  max-width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  padding: 48px;

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
`;

export const TabImageContainer = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  height: fit-content;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 16px;
  background: ${({ theme }) =>
    `${theme.colors.primary[50]}, ${theme.colors.base}`};
  overflow: hidden;
  max-width: 500px;

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
    min-height: 280px;
    max-width: 100%;
    max-height: 326px;
  }
`;
